import style from './CartItem.module.scss'

interface HighlightWordProps {
  keyword: string[]
  words?: string
}

const HighlightWord = ({ keyword, words = '' }: HighlightWordProps) => {
  const highlightedText = [...words].map((word, index) => {
    const isHighlighted = keyword.includes(word)
    return isHighlighted
      ? (
        <span key={index} className={style['highlight-word']}>
          {word}
        </span>
      )
      : (
        word
      )
  })

  return <>{highlightedText}</>
}
export default HighlightWord
